import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import KLButton from '../../KLButton';
import { Wrapper } from './styles';

interface NameStepProps {
  onSubmit: (name: string) => void;
  isSubmitting: boolean;
  error?: string;
}

const NameStep: React.FC<NameStepProps> = ({ onSubmit, isSubmitting, error }) => {
  const [name, setName] = useState('');

  const handleSubmit = () => {
    if (name.trim().length > 0) onSubmit(name.trim());
  };

  return (
    <Wrapper>
      <TextField
        label="איך קוראים לכם?"
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={isSubmitting}
        autoComplete="name"
      />
      {error && <div role="alert">{error}</div>}
      <KLButton
        title="קבעו לי תור"
        onClick={handleSubmit}
        disabled={isSubmitting || name.trim().length === 0}
        loading={isSubmitting}
      />
    </Wrapper>
  );
};

export default NameStep;
